import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import {
  NgbModal,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';

@Component({
  selector: 'app-add-update-animal',
  templateUrl: './add-update-animal.component.html',
})

export class AddUpdateAnimalComponent implements OnInit, OnChanges {
  @ViewChild('addAnimalModal') addAnimalModal: ElementRef;
  @Input() modalData: any;
  @Output() notifyClose = new EventEmitter();

  updateFields = new Subject();
  modalReference: NgbModalRef;
  bonitareModalOpened = false;

  modalType: string;
  matricolChild: string;
  ascendenta = '';
  animalForm;
  evaluareGenetica;
  areFatare;
  elemName = 'identificareAnimal';
  submitted = false;
  disabledFields = {};
  disabledSubmit;

  constructor(
    public modalService: NgbModal,
    private animalsTableService: AnimalsTableService,
  ) { }
  ngOnInit(): void { }

  ngOnChanges(changes) {
    if (changes.modalData && this.modalData) {
      this.modalReference = this.modalService.open(this.addAnimalModal, {
        windowClass: 'modal-full',
        scrollable: true,
      });

      this.modalType = this.modalData['modalType'];
      this.matricolChild = this.modalData['matricolChild'] || '';
      this.ascendenta = this.modalData['ascendenta'] || '';
      this.buildForm(this.modalData['animalData']);

      if (this.modalType === 'add-mother') {
        this.animalForm.controls.sex.setValue('2');
      } else if (this.modalType === 'add-father') {
        this.animalForm.controls.sex.setValue('1');
      }
    }
  }

  buildForm(formData?) {
    this.submitted = false;
    this.evaluareGenetica = formData?.evaluare_genetica;
    this.areFatare = formData?.are_fatare;
    this.elemName = 'identificareAnimal';
    this.disabledSubmit = false;

    this.animalForm = new UntypedFormGroup({
      id: new UntypedFormControl(formData ? formData.id : ''),
      numarmatricol: new UntypedFormControl(
        formData ? formData.numarmatricol : '',
        Validators.required),
      nume: new UntypedFormControl(formData ? formData.nume : ''),
      datanastere: new UntypedFormControl(
        formData ? formData.datanastere : ''),
      sex: new UntypedFormControl(
        formData ? formData.sex.toString() : this.modalType === 'add-mother' ? '2' : '1',
        Validators.required),
      color: new UntypedFormControl(
        formData ? (formData.color !== null ? formData.color.toString() : null) : null),
      codtaur: new UntypedFormControl(formData ? formData.codtaur : ''),
      categoriefemela: new UntypedFormControl(
        formData && formData.categoriefemela !== null
          ? formData.categoriefemela.toString() : '0'),
      sistemreproductie: new UntypedFormControl(
        formData && formData.sistemreproductie !== null
          ? formData.sistemreproductie.toString() : '0'),
      tipfatare: new UntypedFormControl(
        formData && formData.tipfatare !== null
          ? formData.tipfatare.toString() : '0'),
      exploatatieid: new UntypedFormControl(
        formData ? formData.exploatatieid : null),
      crescatorid: new UntypedFormControl(
        formData ? formData.crescatorid : null),
      cod_exploatatie: new UntypedFormControl(
        formData ? formData.cod_exploatatie : null),
      cod_crescator: new UntypedFormControl(
        formData ? formData.cod_crescator : null),
      dataintrareinexploatatie: new UntypedFormControl(
        formData ? formData.dataintrareinexploatatie : ''),
      status: new UntypedFormControl(formData ? formData.status : 1),
      tataid: new UntypedFormControl(
        formData ? formData.tataid : null),
      mamaid: new UntypedFormControl(
        formData ? formData.mamaid : null),
      eligibilitatecz: new UntypedFormControl(
        formData ? formData.eligibilitatecz : ''),
      are_certificat_zootehnic: new UntypedFormControl(
        formData && formData.are_certificat_zootehnic ? true: false),
      taraorigineid: new UntypedFormControl(
        formData ? formData.taraorigineid : null),
      taraprovenientaid: new UntypedFormControl(
        formData ? formData.taraprovenientaid : null),
      mamapurtatoareid: new UntypedFormControl(
        formData ? formData.mamapurtatoareid : null),
      mamapurtatoarematricol: new UntypedFormControl(
        formData ? formData.mamapurtatoarematricol : ''),
      sectiune_reg_general: new UntypedFormControl(formData ? formData.sectiune_reg_general : 0),
      sectiune_reg_ro: new UntypedFormControl(formData ? formData.sectiune_reg_ro : 0),
      data_rg_dmy: new UntypedFormControl(formData ? formData.data_rg_dmy : null),
      greutate_nastere: new UntypedFormControl(formData ? formData.greutate_nastere : null),
      gvr120: new UntypedFormControl(formData ? formData.gvr120 : null),
      smz120: new UntypedFormControl(formData ? formData.smz120 : null),
      gvr200: new UntypedFormControl(formData ? formData.gvr200 : null),
      smz200: new UntypedFormControl(formData ? formData.smz200 : null),
      gvr365: new UntypedFormControl(formData ? formData.gvr365 : null),
      smz365: new UntypedFormControl(formData ? formData.smz365 : null),
      dm: new UntypedFormControl(formData ? formData.dm : null),
      ds: new UntypedFormControl(formData ? formData.ds : null),
      af: new UntypedFormControl(formData ? formData.af : null),
      cr: new UntypedFormControl(formData ? formData.cr : null),
      ifnais: new UntypedFormControl(formData ? formData.ifnais : null),
      crsevr: new UntypedFormControl(formData ? formData.crsevr : null),
      dmsev: new UntypedFormControl(formData ? formData.dmsev : null),
      dssev: new UntypedFormControl(formData ? formData.dssev : null),
      isevr: new UntypedFormControl(formData ? formData.isevr : null),
      avel: new UntypedFormControl(formData ? formData.avel : null),
      alait: new UntypedFormControl(formData ? formData.alait : null),
      ivmat: new UntypedFormControl(formData ? formData.ivmat : null),
      fileidfisabonitare: new UntypedFormControl(
        formData ? formData.fileidfisabonitare : null),
      filename_fisabonitare: new UntypedFormControl(
        formData ? formData.filename_fisabonitare : ''),
      file_id_apr_feno: new UntypedFormControl(
        formData ? formData.file_id_apr_feno : null),
      file_name_apr_feno: new UntypedFormControl(
        formData ? formData.file_name_apr_feno : ''),
      docnr_apr_feno: new UntypedFormControl(
        formData ? formData.docnr_apr_feno : ''),
      data_apr_feno: new UntypedFormControl(
        formData ? formData.data_apr_feno : ''),
      rase: new UntypedFormArray([]),
      poze: new UntypedFormArray([]),
      autorizatii_monta: new UntypedFormArray([]),
      test_adn: new UntypedFormArray([]),
      test_adn_files: new UntypedFormArray([]),
      corespunde_standard: new UntypedFormControl(formData ? formData.corespunde_standard : true),
      hist_corespunde_standard: new UntypedFormArray([]),
      are_avizare_tauri: new UntypedFormControl(formData?.are_avizare_tauri),
      ascendenta: new UntypedFormControl(this.ascendenta),
    });

    if (
      !this.animalForm.value.id &&
      (this.modalType == 'add-father' || this.modalType == 'add-mother')
    ) {
      this.animalForm.controls.status.setValue(-1);
    }

    this.adaugaRase(formData);
    this.adaugaPoze(formData);
    this.adaugaAutorizatiiMonta(formData);
    this.adaugaTestADN(formData);
    this.adaugaTestADNFiles(formData);
    this.adaugaHistCorespundeStandard(formData);
    this.getDisabledFields(formData ? formData.disabled_fields : {});
  }

  getDisabledFields (dFields) {
    this.disabledFields = dFields || {};

    if (['view', 'add-father', 'add-mother'].includes(this.modalType)) {
      for (const key of Object.keys(this.animalForm.value)) {
        this.disabledFields[key] = true;
      }
    }
  }

  adaugaRase(formData) {
    let raseList = [{
      raceid: null,
      val: null,
    }];

    if (formData && formData.rase && formData.rase.length) {
      raseList = formData.rase;
    }

    for (let i = 0; i < raseList.length; i++) {
      let rasa = raseList[i];

      let rasaForm = new UntypedFormGroup({
        raceid: new UntypedFormControl(rasa.raceid),
        val: new UntypedFormControl(rasa.val),
      });

      this.animalForm.controls.rase.push(rasaForm);
    }
  }

  adaugaPoze(formData) {
    if (!formData || !formData.poze) {
      return;
    }

    for (let i = 0; i < formData.poze.length; i++) {
      let poza = formData.poze[i];
      let pozaForm = new UntypedFormGroup({
        fileid: new UntypedFormControl(poza.fileid),
        uploaded_file_name: new UntypedFormControl(poza.uploaded_file_name),
        filetype: new UntypedFormControl(poza.filetype),
      });
      this.animalForm.controls.poze.push(pozaForm);
    }
  }

  adaugaAutorizatiiMonta(formData) {
    if (!formData || !formData.autorizatii_monta) {
      return;
    }

    for (let i = 0; i < formData.autorizatii_monta.length; i++) {
      let autorizatie = formData.autorizatii_monta[i];

      let autorizatieForm = new UntypedFormGroup({
        id: new UntypedFormControl(autorizatie['id']),
        nr_document: new UntypedFormControl(autorizatie['nr_document'], Validators.required),
        data_document: new UntypedFormControl(autorizatie['data_document_dmy'], Validators.required),
        emitent: new UntypedFormControl(autorizatie['emitent'], Validators.required),
        data_inceput: new UntypedFormControl(autorizatie['data_inceput_dmy'], Validators.required),
        data_sfarsit: new UntypedFormControl(autorizatie['data_sfarsit_dmy'], Validators.required),
        file_id: new UntypedFormControl(autorizatie['file_id']),
        file_name: new UntypedFormControl(autorizatie['file_name']),
      });

      this.animalForm.controls.autorizatii_monta.push(autorizatieForm);
    }
  }

  adaugaTestADN(formData) {
    if (!formData || !formData.test_adn) {
      return;
    }

    for (let i = 0; i < formData.test_adn.length; i++) {
      let testADN = formData.test_adn[i];

      let testADNForm = new UntypedFormGroup({
        id: new UntypedFormControl(testADN.id),
        metoda: new UntypedFormControl(testADN.metoda),
        tip: new UntypedFormControl(testADN.tip),
        id_rg: new UntypedFormControl(testADN.id_rg),
        numar_adn: new UntypedFormControl(testADN.numar_adn),
        afiseaza_in_cz: new UntypedFormControl(testADN.afiseaza_in_cz),
        data_eliberarii: new UntypedFormControl(testADN.data_eliberarii),
        readonly: new UntypedFormControl(testADN.readonly),
      });

      this.animalForm.controls.test_adn.push(testADNForm);
    }
  }

  adaugaTestADNFiles(formData) {
    if (!formData || !formData.test_adn_files) {
      return;
    }

    for (let i = 0; i < formData.test_adn_files.length; i++) {
      let testADNFile = formData.test_adn_files[i];

      let testADNFileForm = new UntypedFormGroup({
        id: new UntypedFormControl(testADNFile.id),
        fileid: new UntypedFormControl(testADNFile.fileid),
        uploaded_file_name: new UntypedFormControl(testADNFile.uploaded_file_name),
      });

      this.animalForm.controls.test_adn_files.push(testADNFileForm);
    }
  }

  adaugaHistCorespundeStandard(formData) {
    if (!formData || !formData.hist_corespunde_standard) {
      return;
    }

    for (let i = 0; i < formData.hist_corespunde_standard.length; i++) {
      let item = formData.hist_corespunde_standard[i];

      let form = new UntypedFormGroup({
        data_dmy: new UntypedFormControl(item.data_dmy),
        status_vechi: new UntypedFormControl(item.status_vechi),
        status_nou: new UntypedFormControl(item.status_nou),
        observatie: new UntypedFormControl(item.observatie),
        username: new UntypedFormControl(item.username),
        user_full_name: new UntypedFormControl(item.user_full_name),
      });

      this.animalForm.controls.hist_corespunde_standard.push(form);
    }
  }

  disableSubmitButton(event) {
    if (event === true) {
      this.disabledSubmit = true;
    } else {
      this.disabledSubmit = false;
    }
  }

  get poze(): UntypedFormArray {
    return this.animalForm.get('poze') as UntypedFormArray;
  }

  bonitareModalChanged(event) {
    this.bonitareModalOpened = event;
  }

  scrollToElement(elem) {
    let domElem = document.querySelector(elem);

    if (!domElem) {
      return;
    }

    this.elemName = elem;
    domElem.scrollIntoView({behavior: 'smooth'});
  }

  populateFields(event) {
    if (event && event.id) {
      this.animalsTableService.getAnimalAPI(event.id).subscribe(response => {
        this.modalData['animalData'] = response;
        this.buildForm(this.modalData['animalData']);
      });
    } else {
      this.buildForm();
    }
  }

  onSubmitted() {
    this.submitted = true;

    if (this.animalForm.valid) {
      this.animalsTableService
        .updateAnimal(this.animalForm.value)
        .subscribe(response => {
          this.modalReference.close();
          this.notifyClose.emit(response);
        });
    } else {
      this.scrollToElement('.card:has(.ng-invalid)');
    }
  }

  closeUpdateModal() {
    this.modalReference.close();
    this.notifyClose.emit(this.animalForm.value);
  }

  updateFieldsTrigger() {
    this.updateFields.next(null);
  }
}
